import React from 'react'

export default function ArrowIconBack(props) {
    return (
        <svg width="18" className={props.className} height="14" viewBox="0 0 18 14" fill="none" xmlns="http://www.w3.org/2000/svg">
            <path fillRule="evenodd" clipRule="evenodd" d="M18 5.75073L4.94526 5.75073L9.0379 1.78218L7.21876 0L0 6.99991L7.21876 14L9.0379 12.218L4.94526 8.24945H18V5.75073Z" fill="black" />
        </svg>
    )
}
